import React, {useMemo} from 'react';
import {Stack} from "@mui/material";
import {useParams} from "react-router";
import useChatMessagesStore from "../../../store/useChatMessagesStore";
import {EmptyStateNoChat, EmptyStateNoMessages} from "./EmptyStates";
import MessagesContainer from "./MessagesContainer";

const Messages = () => {
    const {chatId} = useParams();
    const messages = useChatMessagesStore(state => state.messagesByChat[chatId]);

    const lastUserMessageTrigger = useMemo(() => {
        if (!messages?.length) return null;
        for (let i = messages.length - 1; i >= 0; i -= 1) {
            const message = messages[i];
            const role = message.role || 'user';
            if (role === 'user') {
                return message.id || `${chatId}-${i}`;
            }
        }
        return null;
    }, [messages, chatId]);

    return (
        <Stack
            sx={{
                overflow: 'hidden',
                height: '100%',
                minHeight: 0,
                position: 'relative',
            }}
        >
            {!chatId && <EmptyStateNoChat/>}

            {chatId && messages?.length === 0 && <EmptyStateNoMessages/>}

            {chatId && messages?.length > 0 && (
                <MessagesContainer
                    messages={messages}
                    newUserMessageTrigger={lastUserMessageTrigger}
                />
            )}
        </Stack>
    );
};

export default Messages;